<script>
export default {
  name: 'RedirectNotification',
  props: {
    remaining: {
      type: String,
      required: true,
    },
  },
};
</script>

<template lang="pug">
div.notification.b--green.ba.bg-black-dark-overlay.tc.pa3.relative()
  p.pa2.fw6.f7.white.tc
    icon.mr2.w1.fill-green.v-mid(name="warning")
    | {{ $t('Redirecting to the launcher in') }} {{ remaining }}s

</template>
